module.exports = __webpack_public_path__ + "img/logo_hello_list.f60a9e2e.png";